import React from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import { useState } from "react";
import { triggerNotification } from "../../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config";
import { useEffect } from "react";
import Spinner from "../../../component/loadingbar/Spinner";
import countries from "../../../assetsCon/assets/countryList/countries.json";

const AddLeadProfile = () => {
  const { id } = useParams();
  const token = config.token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  //--------------------------------- manage state ---------------------------------
  const [employees, setEmployees] = useState([]);
  const [formData, setFormData] = useState({
    first_name_of_lead: "",
    last_name_of_lead: "",
    email_1: "",
    email_2: "",
    phone_number: "",
    address_line_1: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
    dob: "",
    gender: "",
    type_of_lead: "",
    lead_from: "internal",
    lead_source_type: "",
    reference_code: "",
    sales_exe_id1: "",
    sales_exe_id2: "",
    tele_exec_id1: "",
    tele_exec_id2: "",
    support_exec1: "",
    support_exec2: "",
    date_of_joining: "",
    sales_history: "0",
  });

  useEffect(() => {
    console.log(formData.lead_from);
  }, [formData]);
  const [manageHistory, setManageHistory] = useState({
    lead_source_type: "",
    reference_code: "",
    sales_exe_id1: "",
    sales_exe_id2: "",
    tele_exec_id1: "",
    tele_exec_id2: "",
    support_exec1: "",
    support_exec2: "",
  });
  const leadFromRadioChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      lead_source_type: "",
      lead_from: event.target.id,
    }));
  };
  const handleStateChange = async (e) => {
    if (e.target.name === "country") {
      setFormData((prevData) => ({
        ...prevData,
        country: e.target.value,
        state: "",
        city: "",
      }));
      return;
    }
    if (e.target.name === "state") {
      setFormData((prevData) => ({
        ...prevData,
        state: e.target.value,
        city: "",
      }));
      return;
    }
    if (e.target.name === "lead_source_type") {
      setFormData((prevData) => ({
        ...prevData,
        lead_source_type: e.target.value,
        reference_code: "",
        sales_exe_id1: "",
        sales_exe_id2: "",
        tele_exec_id1: "",
        tele_exec_id2: "",
        support_exec1: "",
        support_exec2: "",
      }));
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  //--------------------------------- get/read sales for dropdown ----------------------------------r
  useEffect(() => {
    setLoading(true);
    fetch(`${config.host_url}sales/`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setEmployees(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching sales type:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);

  //--------------------------------- get/read lead profile for dropdown ----------------------------------r
  const getLeadProfileData = () => {
    setLoading(true);
    fetch(`${config.host_url}lead-profile/${decodeURIComponent(atob(id))}`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.status === 200) {
          console.log("get time: ", data.data);
          await setFormData(data.data);
          const filterDateOfJoining = data.data.date_of_joining.split("T")[0];
          const filterDateOfBirth = data.data.dob.split("T")[0];
          setFormData((prevData) => ({
            ...prevData,
            lead_source_type: `${data.data.lead_source_type}`,
            reference_code: `${data.data.reference_code}`,
            sales_exe_id1: `${data.data.sales_exe_id1}`,
            sales_exe_id2: `${data.data.sales_exe_id2}`,
            tele_exec_id1: `${data.data.tele_exec_id1}`,
            tele_exec_id2: `${data.data.tele_exec_id2}`,
            support_exec1: `${data.data.support_exec1}`,
            support_exec2: `${data.data.support_exec2}`,
            date_of_joining: filterDateOfJoining,
            dob: filterDateOfBirth,
            sales_history: "0",
          }));
          setManageHistory({
            lead_source_type: `${data.data.lead_source_type}`,
            reference_code: `${data.data.reference_code}`,
            sales_exe_id1: `${data.data.sales_exe_id1}`,
            sales_exe_id2: `${data.data.sales_exe_id2}`,
            tele_exec_id1: `${data.data.tele_exec_id1}`,
            tele_exec_id2: `${data.data.tele_exec_id2}`,
            support_exec1: `${data.data.support_exec1}`,
            support_exec2: `${data.data.support_exec2}`,
          });
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching sales type:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (id !== undefined) {
      getLeadProfileData();
    }
  }, [id]);

  // --------------------------------------- submit form -----------------------------------C--U
  useEffect(() => {
    if (
      id &&
      (formData.lead_source_type !== manageHistory.lead_source_type ||
        formData.tele_exec_id1 !== manageHistory.tele_exec_id1 ||
        formData.tele_exec_id2 !== manageHistory.tele_exec_id2 ||
        formData.support_exec1 !== manageHistory.support_exec1 ||
        formData.support_exec2 !== manageHistory.support_exec2 ||
        formData.sales_exe_id1 !== manageHistory.sales_exe_id1 ||
        formData.sales_exe_id2 !== manageHistory.sales_exe_id2 ||
        formData.reference_code !== manageHistory.reference_code)
    ) {
      setFormData((prevData) => ({
        ...prevData,
        sales_history: "1",
      }));
    } else if (id) {
      setFormData((prevData) => ({
        ...prevData,
        sales_history: "0",
      }));
    }
  }, [formData, manageHistory, id]);

  const createLeadProfileBtn = async (e) => {
    if (
      !formData.first_name_of_lead?.trim() ||
      !formData.last_name_of_lead?.trim() ||
      !formData.email_1?.trim() ||
      !formData.email_2?.trim() ||
      !formData.phone_number?.trim() ||
      !formData.address_line_1?.trim() ||
      !formData.city?.trim() ||
      !formData.state?.trim() ||
      !formData.country?.trim() ||
      !formData.postal_code?.trim() ||
      !formData.dob?.trim() ||
      !formData.gender?.trim() ||
      !formData.type_of_lead?.trim() ||
      !formData.lead_from?.trim() ||
      !formData.lead_source_type?.trim() ||
      (formData.lead_source_type === "referal" &&
        !formData.reference_code?.trim()) ||
      (formData.lead_source_type === "through_sales_exec" &&
        (!formData.sales_exe_id1 ||
          !formData.sales_exe_id2 ||
          !formData.tele_exec_id1 ||
          !formData.tele_exec_id2 ||
          !formData.support_exec1 ||
          !formData.support_exec2)) ||
      (formData.lead_source_type === "telecalling" &&
        (!formData.sales_exe_id1 ||
          !formData.sales_exe_id2 ||
          !formData.tele_exec_id1 ||
          !formData.tele_exec_id2 ||
          !formData.support_exec1 ||
          !formData.support_exec2)) ||
      (formData.lead_source_type === "organic_query" &&
        (!formData.sales_exe_id1 ||
          !formData.sales_exe_id2 ||
          !formData.tele_exec_id1 ||
          !formData.tele_exec_id2 ||
          !formData.support_exec1 ||
          !formData.support_exec2)) ||
      (formData.lead_source_type === "through_sales_support_exec" &&
        (!formData.sales_exe_id1 ||
          !formData.sales_exe_id2 ||
          !formData.tele_exec_id1 ||
          !formData.tele_exec_id2 ||
          !formData.support_exec1 ||
          !formData.support_exec2)) ||
      !formData.date_of_joining?.trim()
    ) {
      triggerNotification("error", "Input fields cannot be empty!!");
      return;
    }

    // --- Email validation ---
    const validateEmail = (email) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailRegex.test(email);
    };
    if (!validateEmail(formData.email_1) || !validateEmail(formData.email_2)) {
      triggerNotification("error", "Please enter a valid email address");
      console.log(validateEmail(formData.email_1));
      console.log(formData.email_1, " ", formData.email_2);
      console.log(validateEmail(formData.email_2));
      return;
    }

    // Call the API to create a employee with formData
    try {
      if (!token) {
        triggerNotification("error", "Please log in to create a employee");
        return;
      }

      await fetch(
        `${config.host_url}lead-profile/${
          id ? decodeURIComponent(atob(id)) : ""
        }`,
        {
          method: id ? "PUT" : "POST",
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      ).then((data) => {
        if (data.status === 200) {
          triggerNotification(
            "success",
            `Lead profile ${id ? "updated" : "created"} successfully.`
          );
          setFormData({
            first_name_of_lead: "",
            last_name_of_lead: "",
            email_1: "",
            email_2: "",
            phone_number: "",
            address_line_1: "",
            city: "",
            state: "",
            country: "",
            postal_code: "",
            dob: "",
            gender: "",
            type_of_lead: "",
            lead_from: "internal",
            lead_source_type: "",
            reference_code: "",
            sales_exe_id1: "",
            sales_exe_id2: "",
            tele_exec_id1: "",
            tele_exec_id2: "",
            support_exec1: "",
            support_exec2: "",
            date_of_joining: "",
            sales_history: "0",
          });
          navigate("/viewleadprofiles");
        } else if (data.status === 400) {
          triggerNotification("error", `Validation Error`);
        } else if (data.status === 401) {
          triggerNotification("error", "Unauthenticated user!");
        } else {
          triggerNotification("error", "Internal Server Error");
        }
      });
    } catch (error) {
      triggerNotification(
        "error",
        "Some Error Occurred!! Please try again later"
      );
    }
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setFormData({
      first_name_of_lead: "",
      last_name_of_lead: "",
      email_1: "",
      email_2: "",
      country: "",
      address_line_1: "",
      state: "",
      city: "",
      postal_code: "",
      gender: "",
      dob: "",
      date_of_joining: "",
      phone_number: "",
      lead_source_type: "",
      type_of_lead: "",
      lead_from: "internal",
      reference_code: "",
      sales_exe_id1: "",
      sales_exe_id2: "",
      tele_exec_id1: "",
      tele_exec_id2: "",
      support_exec1: "",
      support_exec2: "",
      sales_history: "0",
    });

    if (id) {
      navigate("/viewleadprofiles");
    }
  };

  return (
    <>
      <Breadcrumb txt="Manage Lead Profile" subpath={["Add Lead Profile"]} />

      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Lead Profile</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* first | last name */}
                <div className="row">
                  {/* First Name */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="first_name_of_lead"
                        id="first_name_of_lead"
                        placeholder="First Name"
                        value={formData.first_name_of_lead}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="first_name_of_lead"> First Name</label>
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6">
                    <div className="form-floating  form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="last_name_of_lead"
                        id="last_name_of_lead"
                        placeholder="Last Name"
                        value={formData.last_name_of_lead}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="last_name_of_lead"> Last Name</label>
                    </div>
                  </div>
                </div>
                {/* email 1 | email 2 */}
                <div className="row">
                  {/* email 1 */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="email_1"
                        id="email_1"
                        placeholder="Email 1"
                        value={formData.email_1}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="email_1"> Email 1</label>
                    </div>
                  </div>

                  {/* email 2 */}
                  <div className="col-md-6">
                    <div className="form-floating  form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="email_2"
                        id="email_2"
                        placeholder="Email 2"
                        value={formData.email_2}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="email_2">Email 2</label>
                    </div>
                  </div>
                </div>
                {/* Address */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="address_line_1"
                    id="address_line_1"
                    placeholder="Address"
                    value={formData.address_line_1}
                    onChange={handleStateChange}
                    autoComplete="off"
                  />
                  <label htmlFor="address_line_1"> Address</label>
                </div>
                {/* country  | state */}
                <div className="row">
                  {/* Country */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <select
                        className="form-select mx-auto"
                        name="country"
                        id="country"
                        value={formData.country}
                        onChange={handleStateChange}
                      >
                        <option
                          value=""
                          disabled
                          selected
                          className="text-center"
                        >
                          ---- Select Country ----
                        </option>
                        {countries &&
                          countries.country &&
                          countries.country.map((cnt) => (
                            <option key={cnt} value={cnt}>
                              {cnt}
                            </option>
                          ))}
                      </select>
                      <label htmlFor="country">Country</label>
                    </div>
                  </div>

                  {/* state */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <select
                        className="form-select mx-auto"
                        name="state"
                        id="state"
                        value={formData.state}
                        onChange={handleStateChange}
                      >
                        <option
                          value=""
                          disabled
                          selected
                          className="text-center"
                        >
                          ---- Select State ----
                        </option>
                        {formData.country ? (
                          countries &&
                          countries.state &&
                          countries.state[formData.country] &&
                          countries.state[formData.country].map((cnt) => (
                            <option key={cnt} value={cnt}>
                              {cnt}
                            </option>
                          ))
                        ) : (
                          <option disabled value="">
                            Please select country first
                          </option>
                        )}
                      </select>
                      <label htmlFor="state">State</label>
                    </div>
                  </div>
                </div>
                {/* city  | postal_code */}
                <div className="row">
                  {/* city */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <select
                        className="form-select mx-auto"
                        name="city"
                        id="city"
                        value={formData.city}
                        onChange={handleStateChange}
                      >
                        <option
                          value=""
                          disabled
                          selected
                          className="text-center"
                        >
                          ---- Select City ----
                        </option>
                        {formData.state ? (
                          countries &&
                          countries.city &&
                          countries.city[formData.state] &&
                          countries.city[formData.state].map((stt) => (
                            <option key={stt} value={stt}>
                              {stt}
                            </option>
                          ))
                        ) : (
                          <option disabled value="">
                            Please select state first
                          </option>
                        )}
                      </select>
                      <label htmlFor="city">City</label>
                    </div>
                  </div>

                  {/* postal_code */}
                  <div className="col-md-6">
                    <div className="form-floating  form-floating-outline mb-4">
                      <input
                        type="number"
                        className="form-control"
                        name="postal_code"
                        id="postal_code"
                        placeholder="Postal Code"
                        value={formData.postal_code}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="postal_code">Postal Code</label>
                    </div>
                  </div>
                </div>
                {/* dob  | gender */}
                <div className="row">
                  {/* Gender */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <select
                        className="form-select"
                        name="gender"
                        id="gender"
                        aria-label="Select Gender"
                        value={formData.gender}
                        onChange={handleStateChange}
                      >
                        <option value="" disabled selected>
                          Select Gender
                        </option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                      <label htmlFor="gender">Gender</label>
                    </div>
                  </div>

                  {/* dob  */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="date"
                        className="form-control"
                        name="dob"
                        id="dob"
                        placeholder="Date Of Birth"
                        value={formData.dob}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="dob">Date Of Birth</label>
                    </div>
                  </div>
                </div>
                {/* phone_number | date_of_joining */}
                <div className="row">
                  {/* date_of_joining */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="date"
                        className="form-control"
                        name="date_of_joining"
                        id="date_of_joining"
                        placeholder="Date Of Joining"
                        value={formData.date_of_joining}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="date_of_joining">Date Of Joining</label>
                    </div>
                  </div>

                  {/* phone_number  */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="number"
                        className="form-control"
                        name="phone_number"
                        id="phone_number"
                        placeholder="Phone Number"
                        value={formData.phone_number}
                        onChange={handleStateChange}
                        autoComplete="off"
                      />
                      <label htmlFor="phone_number">Phone Number</label>
                    </div>
                  </div>
                </div>
                {/* lead_from | type_of_lead   */}
                <div className="row">
                  {/* lead_from  */}
                  <div className="col-md-6">
                    <label className="form-check-label select-none ml-1 mb-2">
                      Lead
                    </label>
                    <div>
                      <div className="form-check form-check-inline ml-1">
                        <input
                          defaultChecked
                          name="form-check-group"
                          className="form-check-input"
                          type="radio"
                          value=""
                          checked={formData.lead_from === "internal"}
                          id="internal"
                          onChange={leadFromRadioChange}
                        />
                        <label
                          className="form-check-label select-none"
                          htmlFor="internal"
                        >
                          Internal Lead
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          name="form-check-group"
                          className="form-check-input"
                          type="radio"
                          value=""
                          checked={formData.lead_from === "external"}
                          id="external"
                          onChange={leadFromRadioChange}
                        />
                        <label
                          className="form-check-label select-none"
                          htmlFor="external"
                        >
                          External Lead
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* type_of_lead  */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <select
                        className="form-select"
                        name="type_of_lead"
                        id="type_of_lead"
                        aria-label="Select type of lead"
                        value={formData.type_of_lead}
                        onChange={handleStateChange}
                      >
                        <option value="" disabled selected>
                          Select type of lead
                        </option>
                        <option value="Student">Student</option>
                        <option value="Teacher">Teacher</option>
                      </select>
                      <label htmlFor="type_of_lead">Type Of Lead</label>
                    </div>
                  </div>
                </div>
                {/* lead_source_type */}
                <div className="col-lg-12">
                  <div className="form-floating form-floating-outline mb-4">
                    <select
                      className="form-select"
                      name="lead_source_type"
                      id="lead_source_type"
                      aria-label="Select lead source type"
                      value={formData.lead_source_type}
                      onChange={handleStateChange}
                    >
                      <option value="" disabled selected>
                        Select lead source type
                      </option>

                      {formData.lead_from === "external" ? (
                        <>
                          <option value="organic_query">Organic Query</option>
                          <option value="telecalling">Telecalling</option>
                          <option value="through_sales_exec">
                            Through Sales Executive
                          </option>
                          <option value="through_sales_support_exec">
                            Through Sales Support Executive
                          </option>
                          <option value="referal">Referal</option>
                        </>
                      ) : (
                        <>
                          <option value="Shortlisted">Short Listed</option>
                          <option value="Query">Query</option>
                        </>
                      )}
                    </select>
                    <label htmlFor="lead_source_type">Lead Source Type</label>
                  </div>
                </div>
                {/* Reference Code */}
                {formData.lead_source_type === "referal" && (
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className="form-control"
                      name="reference_code"
                      id="reference_code"
                      placeholder="Reference Code"
                      value={formData.reference_code}
                      onChange={handleStateChange}
                      autoComplete="off"
                    />
                    <label htmlFor="reference_code">Reference Code</label>
                  </div>
                )}
                {/* sales_exe_id */}
                {(formData.lead_source_type === "through_sales_exec" ||
                  formData.lead_source_type === "telecalling" ||
                  formData.lead_source_type === "through_sales_support_exec" ||
                  formData.lead_source_type === "organic_query") && (
                  <div className="row">
                    {/* sales_exe_id1 */}
                    <div className="col-md-6">
                      <div className=" form-floating form-floating-outline mb-4">
                        <select
                          className="form-select mx-auto"
                          name="sales_exe_id1"
                          id="sales_exe_id1"
                          value={formData.sales_exe_id1}
                          onChange={handleStateChange}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            ---- Select Primary Sales Executive ----
                          </option>
                          {employees &&
                            employees.map((emp) => (
                              <option key={emp.sid} value={emp.sid}>
                                {emp.first_name +
                                  " " +
                                  emp.last_name +
                                  " - " +
                                  emp.sales_emp_type}
                              </option>
                            ))}
                        </select>
                        <label htmlFor="sales_exe_id1">
                          Primary Sales Executive
                        </label>
                      </div>
                    </div>
                    {/* sales_exe_id2 */}
                    <div className="col-md-6">
                      <div className=" form-floating form-floating-outline mb-4">
                        <select
                          className="form-select mx-auto"
                          name="sales_exe_id2"
                          id="sales_exe_id2"
                          value={formData.sales_exe_id2}
                          onChange={handleStateChange}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            ---- Select Secondary Sales Executive ----
                          </option>
                          {employees &&
                            employees.map((emp) => (
                              <option key={emp.sid} value={emp.sid}>
                                {emp.first_name +
                                  " " +
                                  emp.last_name +
                                  " - " +
                                  emp.sales_emp_type}
                              </option>
                            ))}
                        </select>
                        <label htmlFor="sales_exe_id2">
                          Secondary Sales Executive
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                {/* tele_exec_id */}
                {(formData.lead_source_type === "through_sales_exec" ||
                  formData.lead_source_type === "telecalling" ||
                  formData.lead_source_type === "through_sales_support_exec" ||
                  formData.lead_source_type === "organic_query") && (
                  <div className="row">
                    {/* tele_exec_id1 */}
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select mx-auto"
                          name="tele_exec_id1"
                          id="tele_exec_id1"
                          value={formData.tele_exec_id1}
                          onChange={handleStateChange}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            ---- Select Primary Telecaller ----
                          </option>
                          {employees &&
                            employees.map((emp) => (
                              <option key={emp.sid} value={emp.sid}>
                                {emp.first_name +
                                  " " +
                                  emp.last_name +
                                  " - " +
                                  emp.sales_emp_type}
                              </option>
                            ))}
                        </select>
                        <label htmlFor="tele_exec_id1">
                          Primary Telecaller
                        </label>
                      </div>
                    </div>
                    {/* tele_exec_id2 */}
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select mx-auto"
                          name="tele_exec_id2"
                          id="tele_exec_id2"
                          value={formData.tele_exec_id2}
                          onChange={handleStateChange}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            ---- Select Secondary Telecaller ----
                          </option>
                          {employees &&
                            employees.map((emp) => (
                              <option key={emp.sid} value={emp.sid}>
                                {emp.first_name +
                                  " " +
                                  emp.last_name +
                                  " - " +
                                  emp.sales_emp_type}
                              </option>
                            ))}
                        </select>
                        <label htmlFor="tele_exec_id2">
                          Secondary Telecaller
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                {/* through_sales_support_exec */}
                {(formData.lead_source_type === "through_sales_exec" ||
                  formData.lead_source_type === "telecalling" ||
                  formData.lead_source_type === "through_sales_support_exec" ||
                  formData.lead_source_type === "organic_query") && (
                  <div className="row">
                    {/* support_exec1 */}
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select mx-auto"
                          name="support_exec1"
                          id="support_exec1"
                          value={formData.support_exec1}
                          onChange={handleStateChange}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            ---- Select Primary Support Executive ----
                          </option>
                          {employees &&
                            employees.map((emp) => (
                              <option key={emp.sid} value={emp.sid}>
                                {emp.first_name +
                                  " " +
                                  emp.last_name +
                                  " - " +
                                  emp.sales_emp_type}
                              </option>
                            ))}
                        </select>
                        <label htmlFor="support_exec1">
                          Primary Support Executive
                        </label>
                      </div>
                    </div>
                    {/* support_exec2 */}
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select mx-auto"
                          name="support_exec2"
                          id="support_exec2"
                          value={formData.support_exec2}
                          onChange={handleStateChange}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            ---- Select Secondary Support Executive ----
                          </option>
                          {employees &&
                            employees.map((emp) => (
                              <option key={emp.sid} value={emp.sid}>
                                {emp.first_name +
                                  " " +
                                  emp.last_name +
                                  " - " +
                                  emp.sales_emp_type}
                              </option>
                            ))}
                        </select>
                        <label htmlFor="support_exec2">
                          Secondary Support Executive
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                {/* submit | cancel */}
                <div className="mt-3 flex justify-content-end">
                  <div className="">
                    {/* clear/ calcel */}
                    <button
                      type="button"
                      className="btn  btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                    {/* submit */}
                    <button
                      type="button"
                      className="btn ml-2 btn-primary"
                      onClick={createLeadProfileBtn}
                    >
                      {id ? "update" : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddLeadProfile;
